import { useState } from "react";

import { CourseInfoTab, CourseQnaTab, TabGroup } from "@/components";

import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { ScheduleResponseDto } from "@shared/generated/api/model";

interface WaitingRoomTabsProps {
  schedule: ScheduleResponseDto;
}

export const WaitingRoomTabs = ({ schedule }: WaitingRoomTabsProps) => {
  const { t } = useCustomTranslation();
  const [isWriting, setIsWriting] = useState(false);

  const handleWriteBtnClick = () => {
    setIsWriting(true);
  };

  const handleWriteClose = () => {
    setIsWriting(false);
  };

  const tabs = [
    {
      id: "course-info",
      label: t("class_information"),
      content: (
        <CourseInfoTab
          schedules={schedule.cycle.schedules}
          currentScheduleId={schedule.id}
          courseType={schedule.cycle.course.type}
        />
      ),
    },
    {
      id: "course-qna",
      label: t("class_qna"),
      content: (
        <CourseQnaTab
          courseId={schedule.cycle.course.id}
          isWriting={isWriting}
          onCloseWrite={handleWriteClose}
        />
      ),
      showAction: !isWriting,
    },
  ];

  return (
    <TabGroup
      tabs={tabs}
      onActionClick={handleWriteBtnClick}
    />
  );
};
